export default __webpack_public_path__ + "static/media/data-icon.8eecfd0c.svg";